import React, { useEffect, useRef } from "react";
import Typed from "typed.js";

import main from "../images/main-image.jpg";

function Home() {
  const typedRef = useRef(null);

  useEffect(() => {
    const typed = new Typed(typedRef.current, {
      strings: ["", "3D Artist", "Designer", "Freelancer", "3D Artist"],
      typeSpeed: 95,
      backSpeed: 60,
      loop: true,
    });

    return () => {
      typed.destroy(); // Cleanup when component unmounts
    };
  }, []);
  return (
    <div>
      <section className="home active section" id="home">
        <div className="container">
          <div className="row" style={{paddingRight:"30px"}}>
            <div className="home-info padd-15">
              <h3 className="hello">
                Hello, my name is
                <span className="name"> Sazid Mostafiz</span>
              </h3>
              <h3 className="my-profession">
                I am a <span ref={typedRef} className="typing"></span>
              </h3>
              <p>
                In my works I tried a lot of different stuff like combining real
                footage with 3D animations, motion graphics, graphic design ,
                vfx and a bunch of other cool things. I am crazy about
                discovering new techniques and styles to improve my skills.
              </p>
              <a href="/contact" data-section-index="1" className="btn hire-me">
                Contact me
              </a>
            </div>
            <div className="home-img padd-15">
              <img src={main} alt="Sazid Mostafiz" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;

